import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadControlWorkViolationByIdFailed,
  loadControlWorkViolationByIdSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadViolationControlWorkById(action) {
  try {
    const url = `${BACKEND_URL}/proxy/backend/api/v2/dict/work-rest-violations/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);

    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadControlWorkViolationByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadControlWorkViolationByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadControlWorkViolationByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
